import moment from 'moment';
import momentTimeZone from 'moment-timezone';
import jMoment from 'moment-jalaali';
import iMoment from 'moment-hijri';
import * as Storage from './Storage';
export const SaadDate = (async () => {
  const userOptions = await Storage.get('userOptions', true);
  return await class SaadDate {
    constructor() {
      if (userOptions) {
        if (userOptions.calendar === 'fa-IR') {
          jMoment.loadPersian();
        } else if (userOptions.calendar === 'ar-SA') {
          const arSALocale = {
            week: {
              dow: 6
            },
            weekdays: ["الأحد", "الأثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعه", "السبت"],
            weekdaysShort: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
            weekdaysMin: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
            iMonths: 'محرم_صفر_ربيع الأول_ربيع الثاني_جمادى الأولى_جمادى الآخرة_رجب_شعبان_رمضان_شوال_ذو القعدة_ذو الحجة'.split('_'),
            iMonthsShort: 'محرم_صفر_ربيع ١_ربيع ٢_جمادى ١_جمادى ٢_رجب_شعبان_رمضان_شوال_ذو القعدة_ذو الحجة'.split('_')
          };
          if (typeof moment.updateLocale === 'function') {
            moment.updateLocale('ar-sa', arSALocale);
          } else {
            let oldLocale = moment.locale();
            moment.defineLocale('ar-sa', arSALocale);
            moment.locale(oldLocale);
          }
        }
      }
    }
    parseDate = (UTC, options = {
      ignoreTimeZone: false,
      showTime: false
    }) => {
      if (!UTC || UTC === null) {
        return false;
      }
      const timeZone = options.ignoreTimeZone ? 'Europe/London' : userOptions.timeZone;
      const format = options.showTime ? "YYYY-M-D HH:mm" : "YYYY-M-D";
      const result = momentTimeZone(UTC).tz(timeZone).format(format);
      return result;
    };
    niceDate = (date, options = {
      showDay: false
    }) => {
      if (!date) {
        return '';
      }
      const dateTime = date.split(" ");
      let calendar = null,
        result = null;
      if (userOptions.calendar === 'fa-IR') {
        calendar = {
          format: dateTime[1] ? `${options.showDay ? "dddd, " : ""}jD jMMMM jYYYY, HH:mm` : `${options.showDay ? "dddd, " : ""}jD jMMMM jYYYY`,
          inputFormat: dateTime[1] ? "YYYY-M-D HH:mm" : "YYYY-M-D"
        };
        result = jMoment(date, calendar.inputFormat).format(calendar.format);
      } else if (userOptions.calendar === 'ar-SA') {
        calendar = {
          format: dateTime[1] ? `${options.showDay ? "dddd، " : ""}iD iMMMM، iYYYY HH:mm` : `${options.showDay ? "dddd, " : ""}iD iMMMM، iYYYY`,
          inputFormat: dateTime[1] ? "YYYY-M-D HH:mm" : "YYYY-M-D"
        };
        result = iMoment(date, calendar.inputFormat).locale("ar-sa").format(calendar.format);
      } else {
        calendar = {
          format: dateTime[1] ? `${options.showDay ? "dddd, " : ""}MMMM D, YYYY HH:mm` : `${options.showDay ? "dddd, " : ""}MMMM D, YYYY`,
          inputFormat: dateTime[1] ? "YYYY-M-D HH:mm" : "YYYY-M-D"
        };
        result = moment(date, calendar.inputFormat).locale('en').format(calendar.format);
      }
      return result;
    };
  };
})();